"use client";

import { useEffect, useRef } from "react";
import { initializeAdvancedTracking } from "@/lib/services/analytics.service";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const initializedRef = useRef(false);

  // Initialize all advanced tracking ONCE
  useEffect(() => {
    if (!initializedRef.current) {
      initializeAdvancedTracking();
      initializedRef.current = true;
    }
  }, []);

  // Suppress extension-related unhandled rejections BEFORE they get logged
  useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reasonStr = String(event.reason);

      // Filter out extension-related errors
      if (
        reasonStr.includes("chrome-extension://") ||
        reasonStr.includes("Failed to fetch") ||
        reasonStr.includes("frame_ant") ||
        reasonStr.includes("AbortError")
      ) {
        // Prevent the error from being logged to console
        event.preventDefault();
        event.stopPropagation();
      }
    };

    // Register this handler early with capture phase
    window.addEventListener("unhandledrejection", handleUnhandledRejection, true);

    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection, true);
    };
  }, []);

  // Track session end on page unload
  useEffect(() => {
    const handleBeforeUnload = () => {
      const sessionId = localStorage.getItem("usland_session_id");
      if (sessionId) {
        const payload = JSON.stringify({
          action: "end",
          sessionId
        });
        navigator.sendBeacon("/api/analytics/session", payload);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return <>{children}</>;
}
